module.exports = __webpack_public_path__ + "assets/sannianjihua.1be60bb1.svg";